module.exports = __webpack_public_path__ + "img/4-21.fd628085.jpg";